import { Scale } from '@blade/common/utils/auto-scale';
import { get } from 'lodash';
import { Legend_Config, Tooltip_Config, AxisConfig } from '@blade-sxp/portrait-center/utils/common-config';
import colors from '@/styles/color.scss';
const formatter = (propeties) => {
    const value = get(propeties, 'value', '');
    return Number(value) > 0 ? value : '';
};
const LabelConfig = {
    show: false,
    position: 'insideRight',
    color: colors.portraitCenterBarhConfigInside,
    fontSize: 13 * Scale,
    formatter,
};
export const barhOption = () => {
    return {
        tooltip: {
            trigger: 'axis',
            axisPointer: {
                // 坐标轴指示器，坐标轴触发有效
                type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
            },
            ...Tooltip_Config,
            backgroundColor: colors.white
        },
        legend: {
            data: ['Real Name', 'No real name'],
            top: 0,
            left: 0,
            textStyle: Legend_Config.textStyle,
            itemWidth: 10 * Scale,
            itemHeight: 10 * Scale,
            itemGap: 32,
            icon: 'circle',
        },
        grid: {
            top: 30 * Scale,
            left: 0,
            right: 20 * Scale,
            bottom: 0,
            containLabel: true,
        },
        xAxis: {
            type: 'value',
            ...AxisConfig,
            axisLine: { show: false }
        },
        yAxis: {
            type: 'category',
            data: [],
            ...AxisConfig,
            axisLine: {
                show: false,
            },
        },
        series: [
            {
                name: 'Real Name',
                type: 'bar',
                stack: '总量',
                label: LabelConfig,
                itemStyle: {
                    color: colors.portraitCenterBarhConfigSeries,
                },
                data: [],
            },
            {
                name: 'No real name',
                type: 'bar',
                stack: '总量',
                label: { ...LabelConfig, position: 'insideLeft' },
                itemStyle: {
                    color: colors.portraitCenterBarhConfigSeriesAdult,
                },
                data: [],
            },
        ],
    };
};
export const backUpSeries = (vue) => ({
    name: vue.$t('stChild').toString(),
    type: 'bar',
    stack: '总量',
    label: { ...LabelConfig, position: 'insideLeft' },
    itemStyle: {
        color: colors.portraitCenterBarhConfigSeriesChild
    },
    data: [],
});
export const backUpAdultSeries = (vue) => ({
    name: vue.$t('stAdult').toString(),
    type: 'bar',
    stack: '总量',
    label: { ...LabelConfig, position: 'insideLeft' },
    itemStyle: {
        color: colors.portraitCenterBrightAgeModeDougnutOption
    },
    data: [],
});
export const backUpGenderSeries = (vue) => ({
    name: vue.$t('male').toString(),
    type: 'bar',
    stack: '总量',
    label: { ...LabelConfig, position: 'insideLeft' },
    itemStyle: {
        color: colors.portraitCenterBarhConfigSeries
    },
    data: [],
});
export const backUpIdentitySeries = (vue) => ({
    name: vue.$t('realName').toString(),
    type: 'bar',
    stack: '总量',
    label: { ...LabelConfig, position: 'insideLeft' },
    itemStyle: {
        color: colors.portraitCenterBarhConfigSeries
    },
    data: [],
});
